import { windowWidth } from "@styles/global";
import styled from "styled-components";

const LoginContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  overflow: auto;
`;

const LoginFormContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  flex-direction: column;

  @media (max-width: ${windowWidth.mobile.large}) {
    width: 90%;
    padding-left: 0px;
    padding-right: 0px;
  }
`;

const LoginFooterContainer = styled.div`
  position: fixed;
  bottom: 0px;
  display: flex;
  justify-content: end;
  width: 100%;
  padding-bottom: 35px;

  @media (max-width: ${windowWidth.tablet}) {
    justify-content: center;
    padding-bottom: 15px;
  }
`;

const LoginTelluriaGroupContainer = styled.a`
  width: 180px;
  margin-top: 50px;
`;

export {
  LoginContainer,
  LoginFormContainer,
  LoginTelluriaGroupContainer,
  LoginFooterContainer
};
